import { useQuery } from '@tanstack/react-query';
import { Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { getCrmAccess } from './api';

/** The database is authoritative; UI role previews never grant CRM access. */
export function RequireCrmAccess() {
  const { user } = useAuth();
  const access = useQuery({ queryKey: ['crm', 'access', user?.id], queryFn: getCrmAccess, enabled: Boolean(user), staleTime: 0 });
  if (access.isPending) return <p role="status" className="p-6">Checking CRM access…</p>;
  if (access.isError) return <div role="alert" className="p-6"><p>CRM access could not be checked.</p><button className="mt-3 text-blue-700 underline" onClick={() => void access.refetch()}>Try again</button></div>;
  if (access.data !== 'admin') return <div className="p-6"><h1 className="text-xl font-semibold">Admin Level 3 access required</h1><p className="mt-2 text-gray-600">The Vendor CRM pilot is restricted to active Admin Level 3 users.</p></div>;
  return <Outlet />;
}
